import {
    mapAtomicFlagName,
    mapDocumentComparisonName,
    mapExpectedFlagStateName,
    mapFallbackDecisionName,
    mapRangeEdgeName
} from '../rules_utils'

const CompositeRuleCard = (props) => {
    const { step, decision, fallbackDecision, floor, ceiling, floorComparisonType, ceilingComparisonType, documentSimilarityThreshold, documentComparisonType, requiredOcrFlags, description } = props
    return (
        <div className="inbox__cell--left" style={{ paddingBottom: "10px" }}>
            <p className="data-field" style={{ marginBottom: "8px" }}>
                <span className="data-field__label dialogTitle">
                    <b>
                        {step}
                    </b>
                </span>
            </p>
            <p className="data-field">
                <span className="data-field__label">
                    Faixa inconclusiva:
                </span>
                <span className="data-field__value" style={{ paddingLeft: '5px' }}>
                    de {floor} ({mapRangeEdgeName(floorComparisonType)}) a {ceiling} ({mapRangeEdgeName(ceilingComparisonType)})
                </span>
            </p>
            <p className="data-field">
                <span className="data-field__label">
                    Similaridade mínima com documento:
                </span>
                <span className="data-field__value" style={{ paddingLeft: '5px' }}>
                    {mapDocumentComparisonName(documentComparisonType)} {documentSimilarityThreshold}
                </span>
            </p>
            <div className="data-field" style={{ paddingBottom: '10px' }}>
                <span className="data-field__label">
                    Indicadores exigidos:
                </span>
                <ul>
                    {
                        requiredOcrFlags.map((requiredFlag) => (
                            <li key={requiredFlag.flag} style={{ marginLeft: '30px', marginTop: '5px' }}>
                                <span className="data-field__value">
                                    {mapAtomicFlagName(requiredFlag.flag)} — {mapExpectedFlagStateName(requiredFlag.expected)}
                                </span>
                            </li>
                        ))
                    }
                </ul>
            </div>
            <p className="data-field">
                <span className="data-field__label">
                    Se a revalidação passar:
                </span>
                <span className="data-field__value" style={{ paddingLeft: '5px' }}>
                    {mapFallbackDecisionName(fallbackDecision)}
                </span>
            </p>
            <p className="data-field">
                <span className="data-field__label">
                    Se a revalidação não passar:
                </span>
                <span className="data-field__value" style={{ paddingLeft: '5px' }}>
                    {decision}
                </span>
            </p>
            <p>
                <span className="data-field__label">
                    Descrição:
                </span>
                <span className="data-field__value" style={{ paddingLeft: '5px' }}>
                    {description}
                </span>
            </p>
        </div>
    )
}

export default CompositeRuleCard
